import { filterItems } from 'common/api/v1/companiesCurrencies';

import * as creditFileSelectors from '../../creditFile/selectors';
import {
    FETCH_ITEMS,
    FETCH_ITEMS_FAILURE,
    FETCH_ITEMS_SUCCESS,
} from '../actionTypes';
import { multiCurrencyActions } from '../reducer';

export default () => (dispatch, getState) => {
    const companyId = creditFileSelectors.getCreditInstallerId(getState());
    dispatch(multiCurrencyActions[FETCH_ITEMS]());

    filterItems(companyId)
        .then((response) =>
            dispatch(
                multiCurrencyActions[FETCH_ITEMS_SUCCESS](response.data.data),
            ),
        )
        .catch((error) =>
            dispatch(
                multiCurrencyActions[FETCH_ITEMS_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
